import React from "react";

const Memory = ({ url, title, date, description, click, id }) => {
  return (
    <div>
      <div class="card" style={{ width: "18rem" }}>
        <img src={url} class="card-img-top" alt="..." />
        <div class="card-body">
          <h5 class="card-title">{title}</h5>
          <br />
          <p>{date}</p>
          <br />
          <br />
          <p class="card-text">{description}</p>
          <br />
          <br />
          <button className="btn btn-danger" onClick={() => click(id)}>
            Edit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Memory;
